import React, { useEffect, useState } from "react";
import SearchCom from "../../../components/SearchCom";
import AddEventModal from "./EventActions";
import EventCard from "./EventCard";

const EventCardGrid = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventData, setEventData] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]); // For filtered results
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/events/get`
      );
      const data = await response.json();
      setEventData(data);
      setFilteredEvents(data); // Initially, display all events
      setLoading(false);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const handleSearch = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filtered = eventData.filter((event) =>
      event.name.toLowerCase().includes(lowerCaseQuery) || // Match by name
      event.location.toLowerCase().includes(lowerCaseQuery) || // Match by location
      event.description.toLowerCase().includes(lowerCaseQuery) // Match by description
    );
    setFilteredEvents(filtered);
  };

  const handleSaveEvent = async (formData, images, eventId) => {
    try {
        const formData_ = new FormData();
        formData_.append("name", formData.name);
        formData_.append("description", formData.description);
        formData_.append("eventLink", formData.eventLink);
        formData_.append("location", formData.location);
        formData_.append("status", "Active");

        const nonFileImages = [];
        if (images && images.length > 0) {
            images.forEach((image, index) => {
                if (image.changed) {
                    formData_.append("images", image.file);
                } else {
                    nonFileImages.push(image.file);
                }
            });
        }

        formData_.append("nonFileImages", JSON.stringify(nonFileImages));
        formData_.append("date", formData.date);
        formData_.append("time", formData.time);
        if (formData.endDate) formData_.append("endDate", formData.endDate);
        if (formData.endTime) formData_.append("endTime", formData.endTime);

        const url = eventId
            ? `${process.env.REACT_APP_BASE_URL}/events/edit/${eventId}`
            : `${process.env.REACT_APP_BASE_URL}/events/add`;

        const response = await fetch(url, {
            method: eventId ? "PUT" : "POST",
            body: formData_,
        });
        window.location.reload();
    } catch (error) {
        console.error("Error saving event:", error);
    }
};

  const handleManageEvent = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  return (
    <div className="bg-gray-100 min-h-screen max-h-screen w-full px-10 overflow-scroll">
      <div className="py-5 mx-auto flex items-center justify-between gap-4">
        <div className="w-[70%] flex gap-6">
          <SearchCom data={eventData} onSearch={handleSearch} />
          <button
            onClick={() => {
              setSelectedEvent(null);
                setIsModalOpen(true);
              }}
              className="bg-gray-900 text-white px-4 py-2 rounded-full hover:bg-gray-800 transition-colors flex items-center gap-2"
              >
              ADD <span>+</span>
              </button>
            </div>
            </div>

            <div className="w-full flex flex-col gap-10 justify-center items-center h-full">
              {filteredEvents.length === 0 && !loading && (
                <div className="flex pt-10 flex-col gap-10 justify-center items-center h-full">
                        <img src="/assets/none.svg" alt="No posts available" />
                        <h2 className="text-2xl font-semibold text-gray-900">No events available</h2>
                    </div>
              )}
            </div>
            <div className="mx-auto mb-6 mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredEvents.map((event) => (
              <EventCard
              key={event._id}
              {...event}
              onManage={() => handleManageEvent(event)}
              />
            ))}
            </div>

            <AddEventModal
            isOpen={isModalOpen}
            onClose={() => {
          setIsModalOpen(false);
          setSelectedEvent(null);
        }}
        eventData={selectedEvent}
        onSave={handleSaveEvent}
      />
    </div>
  );
};

export default EventCardGrid;
